import ResourceCard from "@/components/vetting/ResourceCard";
import CallFormCard from "@/components/CallFormCard";

const ID = { "Podcast List": "podcast-list", "Recommended Books": "recommended-books", "Honouring the Partnership": "honouring-partnership" };

export default function EverydayEssentials({ content }) {
  const items = content.essentials || [];
  return (
    <section className="rounded-2xl border border-[#C9A961]/40 bg-white p-4 sm:p-5" data-testid="everyday-essentials">
      <h2 className="font-serif text-lg sm:text-xl text-[#0A1F44]">Your Everyday Essentials</h2>
      <p className="text-sm text-slate-500 mt-0.5">Keep these handy throughout your first 45 days—and beyond.</p>
      <div className="mt-4 grid gap-2 md:grid-cols-3">
        {items.map((e) => (
          <ResourceCard key={e.label} testid={`essentials-${ID[e.label] || e.label}`}
                        seg={{ t: e.label, u: e.url, kind: e.kind, file_id: e.file_id }} />
        ))}
        <CallFormCard testid="essentials-call-form" />
      </div>
    </section>
  );
}
